export default "__VITE_ASSET__240e21b1__"